
const allowedHostnames = [
  '',
  'localhost',
  'app.crmdelsol.com',
  'app.crmsol.es',
  'crm.crmdelsol.com',
  'app.dev.crmincloud.it',
  'app.test.crmincloud.it',
  'rc.crmincloud.it',
  'rc.test.crmincloud.it',
  'app.demo.crmincloud.it',
  'demo.crmincloud.it',
];



const reactRedirector = () => {
  if (window.location?.pathname?.includes('/landing/mailing/unsubscribe')) {
    return false;
  }
  if (!allowedHostnames.includes(window.location.hostname)) {
    window.location.replace(`/react?${new Date().getTime()}`);
    return true;
  }
  return false;
};

export default reactRedirector;
